import { TIMEFRAMES } from '@witmetrics/utils/constants';
import { getDefinedTimeframe, renderTimeframe } from '@/utils/time';
import type { TimeframeOption } from './types';

export const classes = {
  // Absolute so the list never sets the popover height; the calendar panel does
  wrapper: 'relative w-[210px] self-stretch',
  list: 'absolute inset-0 flex flex-col gap-0.5 py-3 overflow-y-auto',
};

export function buildTimeframeOptions(
  weekStartsOn?: 0 | 1,
  dateFormat?: string
): TimeframeOption[] {
  return Object.values(TIMEFRAMES).map(({ label, value }) => {
    const range = getDefinedTimeframe(value, weekStartsOn);
    return {
      label,
      value,
      range,
      subtitle: renderTimeframe(range[0], range[1], dateFormat),
    };
  });
}
